import { useState, useEffect } from "react";
import { OrderResultInfo } from "../components/order/index";
import Layout from "../components/Layout";
import { getOrderResult } from "../api";

const OrderCard = (props) => {
  const [order, setOrder] = useState(null);
  const [orderable, setOrderable] = useState(null);

  useEffect(() => {
    orderInit();
  }, []);

  const orderInit = () => {
    getOrderResult({ orderId: props?.orderId }).then((response) => {
      setOrder(response?.data.order);
      setOrderable(response?.data.orderable);
    });
  };

  return (
    <Layout>
      <OrderResultInfo order={order} orderable={orderable} />
    </Layout>
  );
};

export default OrderCard;
